import React from "react";
import { MaintainanceRequestCreateScreenContainer } from "src/containers";

export const MaintainanceRequestCreateScreen = () => {
  return <MaintainanceRequestCreateScreenContainer />;
};
